"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeInputValue = normalizeInputValue;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));
var _toArray2 = _interopRequireDefault(require("lodash/toArray"));
var _isCheckable = require("../is-checkable");
/**
 * Extracts non-empty values from an input or input group into a single string or array
 *
 * @param   {HTMLInputElement|HTMLSelectElement|RadioNodeList}   inputOrGroup
 * @returns {string|[string]}
 */
function normalizeInputValue(inputOrGroup) {
  if ((0, _isCheckable.isCheckable)(inputOrGroup) && !inputOrGroup.checked) {
    return ''; // single unchecked checkbox or radio
  }

  if (inputOrGroup[0] && inputOrGroup[0].type === 'checkbox') {
    var _context, _context2;
    return (0, _map.default)(_context = (0, _filter.default)(_context2 = (0, _toArray2.default)(inputOrGroup)).call(_context2, ({
      checked
    }) => checked)).call(_context, ({
      value
    }) => value);
  }
  if (inputOrGroup[0] && inputOrGroup[0].type === 'hidden') {
    var _context3;
    return (0, _map.default)(_context3 = (0, _toArray2.default)(inputOrGroup)).call(_context3, ({
      value
    }) => value);
  }
  if (inputOrGroup.multiple) {
    var _context4, _context5;
    return (0, _map.default)(_context4 = (0, _filter.default)(_context5 = (0, _toArray2.default)(inputOrGroup.options)).call(_context5, ({
      selected,
      value
    }) => selected && value) // Fabric Select hidden input has option with empty value
    ).call(_context4, ({
      value
    }) => value);
  }
  return inputOrGroup.value; // input, select, RadioGroup
}